import { Injectable } from '@angular/core';
import { Asset } from '@gelato-api-ui/core/designs/asset';
import { AssetMetadataService } from '@gelato-api-ui/core/designs/services/asset-metadata.service';
import { UploadedImageColors } from '@gelato-api-ui/core/designs/uploaded-image-data';

@Injectable({
  providedIn: 'root',
})
export class UploadedImageColorsProvider {
  constructor(private readonly assetMetadataService: AssetMetadataService) {}

  get(asset: Asset): UploadedImageColors {
    const assetMetadata = asset?.metadata;
    const fillColors = this.assetMetadataService.getFillColors(assetMetadata);
    const strokeColors = this.assetMetadataService.getStrokeColors(assetMetadata);

    if (!fillColors && !strokeColors) {
      return null;
    }

    return {
      fill: fillColors || null,
      stroke: strokeColors || null,
    };
  }

  getQuantized(asset: Asset): string[] {
    const assetMetadata = asset?.metadata;
    return this.assetMetadataService.getQuantizedColors(assetMetadata);
  }
}
